import React from 'react'

import { mocApy } from 'constants/feature-keys'

import { useFeature } from '@acorns/web-toggles-react'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import {
  BankCardTier,
  useCheckingAccountDisclosureQuery,
} from 'generated/types'
import { useMocApyRate } from 'hooks/useMocApyRate'
import { style } from 'theme'

const StyledContent = styled.div`
  white-space: pre-line;
`

const GreenLink = styled.a`
  color: ${style((theme) => theme.colors.green)};
  font-weight: 600;
  text-decoration: none;
`

export const InvestingHubDisclosureContent = () => {
  const { getRemoteString } = useRemoteStrings()
  return (
    <StyledContent>
      {getRemoteString({ key: 'investing_hub.disclosure.footer' })}
    </StyledContent>
  )
}

export const HomePageDisclosureContent = () => {
  const { StyledRemoteString } = useRemoteStrings()
  return (
    <StyledRemoteString
      stringKey="action_feed.footer.disclosure.markdown.2variable"
      modifiers={[{ bold: 600 }]}
      variables={['https://www.FINRA.org', 'https://www.SIPC.org']}
    />
  )
}

export const BankingHubDisclosureContent = () => {
  const { StyledRemoteString, getRemoteString } = useRemoteStrings()
  const { data, loading } = useCheckingAccountDisclosureQuery()
  const isMoc =
    data?.spendAccount?.bankCardOrder?.bankCardTier === BankCardTier.MightyOak
  const [isMocApyEnabled] = useFeature(mocApy)

  const { mocLiveDate, mocCheckingApy, mocEmergencyApy } = useMocApyRate({
    isMoc: isMoc && isMocApyEnabled,
  })

  const showMoc = isMoc && mocCheckingApy && mocEmergencyApy

  if (loading) {
    return null
  }

  return (
    <>
      <StyledRemoteString
        stringKey="action_feed.footer.disclosure.markdown"
        modifiers={[{ bold: 600 }]}
      />
      <br />
      <br />
      {showMoc && (
        <span>
          {getRemoteString({
            key: 'banking_mighty_oak_disclosure_interest_rate_3variable',
            variables: [mocLiveDate, mocCheckingApy, mocEmergencyApy],
          })}
        </span>
      )}
    </>
  )
}

export const CheckingHomeDisclosureContent = () => {
  const { getRemoteString } = useRemoteStrings()
  const { data, loading } = useCheckingAccountDisclosureQuery()
  const isMoc =
    data?.spendAccount?.bankCardOrder?.bankCardTier === BankCardTier.MightyOak
  const [isMocApyEnabled] = useFeature(mocApy)

  const { mocLiveDate, mocCheckingApy, mocEmergencyApy } = useMocApyRate({
    isMoc: isMoc && isMocApyEnabled,
  })

  const showMoc = isMoc && mocCheckingApy && mocEmergencyApy

  if (loading) {
    return null
  }

  return (
    <>
      ¹ Any balances you hold with Lincoln Savings Bank or nbkc bank, including
      but not limited to those balances held in Acorns Checking accounts are
      added together and are insured up to $250,000 per depositor through
      Lincoln Savings Bank or nbkc bank, Members FDIC. If you have funds jointly
      owned, these funds would be separately insured for up to $250,000 for each
      joint account owner. Lincoln Savings Bank or nbkc bank utilizes a deposit
      network service, which means that at any given time, all, none, or a
      portion of the funds in your Acorns Checking accounts may be placed into
      and held beneficially in your name at other depository institutions which
      are insured by the Federal Deposit Insurance Corporation (FDIC). For a
      complete list of other depository institutions where funds may be placed,
      please visit{' '}
      <GreenLink href={'https://www.cambr.com/bank-list'} target="_blank">
        https://www.cambr.com/bank-list
      </GreenLink>
      . Balances moved to network banks are eligible for FDIC insurance once the
      funds arrive at a network bank. To learn more about pass-through deposit
      insurance applicable to your account, please see the Account
      Documentation. Additional information on FDIC insurance can be found at{' '}
      <GreenLink
        href={'https://www.fdic.gov/resources/deposit-insurance/'}
        target="_blank"
      >
        https://www.fdic.gov/resources/deposit-insurance/.
      </GreenLink>{' '}
      <br />
      <br />
      {showMoc && (
        <span>
          {getRemoteString({
            key: 'banking_mighty_oak_disclosure_interest_rate_3variable',
            variables: [mocLiveDate, mocCheckingApy, mocEmergencyApy],
          })}
        </span>
      )}
    </>
  )
}
